import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "truncate",
  templateUrl: "./truncated-label.component.html",
  styleUrls: ["./truncated-label.component.scss"],
  standalone: false,
})
export class TruncatedLabelComponent implements OnChanges {
  @Input() value: string;
  @Input() chars: number = 50;

  truncated: boolean = false;
  displayed: string;

  ngOnChanges(): void {
    this.truncated = this.value?.length > this.chars;
    if (this.truncated) {
      this.displayed = this.value.slice(0, this.chars);
    } else {
      this.displayed = this.value;
    }
  }
}
